import { RGSActions } from '../config/config.Connections';

export interface SocketState {
  requestType: string,
  serverBusy: boolean,
  command: any,
}

export interface ReceivedMessage {
  ERROR_CODE: number,
  ERROR_MESSAGE: any,
  COMMAND: RGSActions,
  DATA: any,
}

const K_HEARTBEAT_INTERVAL = 30000; 

class WebsocketConnection {

  private props: any;
  private websocket: WebSocket|null;
  private state: SocketState;
  private rcvMessage: ReceivedMessage;
  private active: boolean;

  constructor(_props: any) {
    this.props = {
      ..._props
    }

    this.websocket = null;
    this.active= false;

    this.createSocket(this.props.URL);
 
    this.state = {
			requestType: '',
			serverBusy: false,
			command: null,
		};
		// container for current message formatting needed for ConnectionManager
		this.rcvMessage = {
			ERROR_CODE: 0,
			ERROR_MESSAGE: 'OK',
			COMMAND: null,
			DATA: null,
		} as any;
  }

  // called from connManager
	init() {}

  //creates the socket object
  createSocket(strURL: string) {
		const  that = this;
		this.websocket = null;
    this.websocket = new WebSocket(this.props.URL);
    this.websocket.onmessage = (response) => this.receiveMessage(response);
    this.websocket.onopen = () => {
			this.onReady();
		};
    this.websocket.onclose = (event) => {
		  this.active = false;
			this.websocket = null;
	 		this.onClose(event);
			this.props.onClose();
		};
 
		this.websocket.onerror = function (error: any) {
			that.websocket?.close();
			that.active = false;
			that.websocket = null;
			console.error(`[socket error]: ${error.message}`);
			console.log('socket error code',error);
			that.onError(error);
		};
  }

  // tells if connection needs heartbeat
	getHeartbeatInterval() {
		return K_HEARTBEAT_INTERVAL;
	}

  receiveMessage(newMessage: any) {
		const data = JSON.parse(newMessage.data);
		const { response } = data;
		const { broadcast } = data;
		
		if(broadcast) {
			this.rcvMessage.DATA = { ...broadcast };
			this.rcvMessage.ERROR_CODE = 0;
			this.rcvMessage.ERROR_MESSAGE = "";
 
			this.onBroadcastReceive(this.rcvMessage); 
		}

		if(response) {
			// check incoming message to see if it corresponds to last sent message
			if (response.requestType !== this.state.requestType) {
				// LOG('Websocket: received unexpected answer!');
				//send the message upstairs
				let pMsg = {
					ERROR_CODE: 0,
					ERROR_MESSAGE: 'OK',
					COMMAND: RGSActions.INCOMING,
					DATA: { ...response },
				};
				this.handleUnexpectedMessage(pMsg);
				// early exit so server stays busy
				return;
			}

			this.rcvMessage.DATA = { ...response };
			this.rcvMessage.ERROR_CODE = response.error.errorCode;
			this.rcvMessage.ERROR_MESSAGE = response.error.errorMessage;

			this.onReceive(this.rcvMessage);
			this.setState({
				serverBusy: false,
			});
		};

	
	}

  onError(error: any) {
		// overwritten in ConnectionManager 
	}

	onClose(event: any) {
		// overwritten in ConnectionManager 
		this.props.onClose();   
	}

  setState(_newState: any) {
		this.state = {
			...this.state,
			..._newState,
		};
	}

  // tells if connection is active
	isActive() {
		return this.active;
	}

  onReady() {
		// console.log('WS:onReady called');
		// mark as active
		this.active = true;

		// call external callback if any (app.js might need it)
		if (this.props.onReady) {
			// console.log('WS:props.onReady called!');
			this.props.onReady();
		}
	}

  	// gets called when we have an unasked for message from the platform
	handleUnexpectedMessage(_rcvPayload: any) {
		// overwritten in ConnectionManager. Receives a standard format package (see executeCommand)
	}

	onReceive(_rcvPayload: any) {
		// overwritten in ConnectionManager. Receives a standard format package (see executeCommand)
	}

	onBroadcastReceive(_rcvPayload: any) {
		// overwritten in ConnectionManager. Receives a standard format package (see executeCommand)
	}

	onSend(command: any, data: any) {
		// overwritten in ConnectionManager
	}

  runCommand(command: any) {
		// executed in ConnectionManager
		// preformat the message saving the command that we received in the COMMAND field
		// DATA field will be filled when receiving the answer
		this.rcvMessage = {
			ERROR_CODE: 0,
			ERROR_MESSAGE: 'OK',
			COMMAND: command,
			DATA: null,
		};

		if (true || !this.state.serverBusy) {
			this.setState({
				serverBusy: true,
				//custom for Marlipin
				requestType: command.data.requestType,
			});
			// announce on top
			this.onSend(command.type, command.data);
			// send actual package
	 
			if (this.websocket !== null) {
				this.websocket.send(JSON.stringify(command.data));
			} else {
				// console.log('WS::runCommand: socket is null!');
			}
		}

		return this.state.serverBusy;
	}
}

export default WebsocketConnection;